import { render, staticRenderFns } from "./xysxh.vue?vue&type=template&id=5d49ddc3&scoped=true&"
import script from "./xysxh.vue?vue&type=script&lang=js&"
export * from "./xysxh.vue?vue&type=script&lang=js&"
import style0 from "./xysxh.vue?vue&type=style&index=0&id=5d49ddc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d49ddc3",
  null
  
)

export default component.exports